import VerifyOTPForm from "components/Organisms/login/forms/verifyOtp/verifyOTPForm";
export default function VerifyOTP() {
  return <VerifyOTPForm />;
}
